import { Component, Input, ViewChild } from "@angular/core";
import {
  NavController,
  ModalController,
  AlertController,
  LoadingController,
  NavParams,
  Events
} from "@ionic/angular";
import { ProcessActionComponent } from "../../processAction";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { HttpApiService } from "../../../services/http-api/http-api.service";
import { ConfigService } from "../../../services/config/config.service";

@Component({
  selector: 'app-stone-with-me-single',
  templateUrl: './stone-with-me-single.component.html',
  styleUrls: ['./stone-with-me-single.component.scss']
})
export class StoneWithMeSingleComponent implements ProcessActionComponent {
  @Input() data: any;
  public query: any;
  public type = "SS";
  public cart = true;
  public disable: any = [];

  constructor(
    private authService: AuthenticationService,
    public httpApiService: HttpApiService,
    private alertCtrl: AlertController,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public configService: ConfigService,
    public loadingController: LoadingController,
    public event: Events
  ) { }

  async ngOnInit() {
    await this.getUserDetails();
  }

  async getUserDetails() {
    console.log("************************")
    let userData = await this.authService.userData();
    console.log("userData", userData);
    let res: any;
    res = await this.httpApiService.getUserDetailById(userData.userId);
    console.log("res", res);
    let data = res.json();
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else if (res.status == 400) {
      await this.configService.showToast("error", data.error);
    } else {
      let userData = data.data;
      console.log("**************", userData)
      // this.query = { facetFilters: ['username:Mohammad Ali'] };
      let name = [];
      let transType = [];
      transType.push(this.type)
      name.push(userData.fullName);
      this.disable.push("username");
      this.query = {
        facetFilters: ["transType:" + this.type, "username:" + userData.fullName],
        disjunctiveFacetsRefinements: { transType: transType, username: name }
      };
      console.log("!!!!", this.query)
      // this.query = { disjunctiveFacetsRefinements: {'username': name}, enablePersonalization: false, attributesToRetrieve: ["username"] };
    }
  }
}
